import firebase from '../../config/firebase'
export const getRatings = () => async (dispatch) => {
  const ratingCounts = { total: 0, NS: 0, RST: 0, satisfied: 0, none: 0 };

  const querySnapshot = await firebase.firestore().collection("a4b_chat_rating").get();

  querySnapshot.docs.forEach((doc) => {
    const chatResponse = doc.data().chatResponse;
    ratingCounts[chatResponse] = (ratingCounts[chatResponse] || 0) + 1;
    ratingCounts.total++;
  });

  const ratingSnapshot = await firebase.firestore().collection("new_a4b_chat").get();

  ratingSnapshot.docs.forEach((doc) => {
    if (doc.data().is_reviewed_fan === false) {
      ratingCounts.none++;
    }
  });

  dispatch({
    type: 'GET_RATING',
    payload: ratingCounts,
  });
};
